import React from 'react';
import { makeVar, useReactiveVar } from '@apollo/client';
import { ModalContext } from 'hoc/with-modal';
import { SurfaceNodeType } from 'graphql/types';
import { NodeModalInput } from 'types';

export type ShowNodeModalFunction = (input: NodeModalInput) => void;

const textNodeModalRefVar = makeVar(React.createRef<ModalContext>());
const textSnippetNodeModalVar = makeVar(React.createRef<ModalContext>());
const noteNodeModalVar = makeVar(React.createRef<ModalContext>());
const documentNodeModalVar = makeVar(React.createRef<ModalContext>());
const protocolNodeModalVar = makeVar(React.createRef<ModalContext>());
const risSearchModalVar = makeVar(React.createRef<ModalContext>());
const surfaceNodeModalVar = makeVar(React.createRef<ModalContext>());
const imageNodeModalVar = makeVar(React.createRef<ModalContext>());
const questionnaireNodeModalVar = makeVar(React.createRef<ModalContext>());
const backgroundNodeModalVar = makeVar(React.createRef<ModalContext>());
const formModalVar = makeVar(React.createRef<ModalContext>());

const modalTypeShownVar = makeVar<string>('');

function setModalTypeShown(type: string): void {
  modalTypeShownVar(type);
}

interface UseSurfaceNodeModalsContext {
  modalTypeShown: string;
  setModalTypeShown(type: string): void;
  modalRefs: {
    textNodeModal: React.RefObject<ModalContext>;
    textSnippetNodeModal: React.RefObject<ModalContext>;
    noteNodeModal: React.RefObject<ModalContext>;
    documentNodeModal: React.RefObject<ModalContext>;
    protocolNodeModal: React.RefObject<ModalContext>;
    risSearchModal: React.RefObject<ModalContext>;
    surfaceNodeModal: React.RefObject<ModalContext>;
    imageNodeModal: React.RefObject<ModalContext>;
    questionnaireNodeModal: React.RefObject<ModalContext>;
    formModal: React.RefObject<ModalContext>;
    backgroundNodeModal: React.RefObject<ModalContext>;
  };
  showNodeModal(input: NodeModalInput): void;
  onModalHide({ data }: any): void;
}

export default function useSurfaceNodeModalsContext(): UseSurfaceNodeModalsContext {
  const textNodeModal = textNodeModalRefVar();
  const textSnippetNodeModal = textSnippetNodeModalVar();
  const noteNodeModal = noteNodeModalVar();
  const documentNodeModal = documentNodeModalVar();
  const backgroundNodeModal = backgroundNodeModalVar();
  const protocolNodeModal = protocolNodeModalVar();
  const risSearchModal = risSearchModalVar();
  const surfaceNodeModal = surfaceNodeModalVar();
  const imageNodeModal = imageNodeModalVar();
  const questionnaireNodeModal = questionnaireNodeModalVar();
  const formModal = formModalVar();
  //const questionnaireNodeModal = questionnaireNodeModalVar();

  const modalTypeShown = useReactiveVar(modalTypeShownVar);

  // backgroundNodeModalVar(backgroundNodeModal)
  const references = {
    textNodeModal,
    textSnippetNodeModal,
    noteNodeModal,
    documentNodeModal,
    protocolNodeModal,
    risSearchModal,
    surfaceNodeModal,
    imageNodeModal,
    questionnaireNodeModal,
    backgroundNodeModal,
    formModal,
  };

  function onModalHide({ data }) {
    setModalTypeShown('');
  }

  return {
    modalTypeShown,
    setModalTypeShown,
    modalRefs: references,
    showNodeModal,
    onModalHide,
  };
}

export function useSurfaceNodeModalsOperations(): {
  showNodeModal: ShowNodeModalFunction;
} {
  return { showNodeModal };
}

function getNodeTypeModalRef(type) {
  const textNodeModal = textNodeModalRefVar();
  const textSnippetNodeModal = textSnippetNodeModalVar();
  const noteNodeModal = noteNodeModalVar();
  const documentNodeModal = documentNodeModalVar();
  const protocolNodeModal = protocolNodeModalVar();
  const risSearchModal = risSearchModalVar();
  const surfaceNodeModal = surfaceNodeModalVar();
  const imageNodeModal = imageNodeModalVar();
  const questionnaireNodeModal = questionnaireNodeModalVar();
  const backgroundNodeModal = backgroundNodeModalVar();
  const formModal = formModalVar();

  switch (type) {
    case SurfaceNodeType.Text:
      return textNodeModal.current;
    case SurfaceNodeType.Image:
      return imageNodeModal.current;
    case SurfaceNodeType.Note:
      return noteNodeModal.current;
    case SurfaceNodeType.Protocol:
      return protocolNodeModal.current;
    case SurfaceNodeType.SubSurface:
      return surfaceNodeModal.current;
    case SurfaceNodeType.Document:
      return documentNodeModal.current;
    case SurfaceNodeType.Background:
      return backgroundNodeModal.current;
    case 'RisSearch':
      return risSearchModal.current;
    case SurfaceNodeType.Questionnaire:
      return questionnaireNodeModal.current;
    case SurfaceNodeType.TextSnippet:
      return textSnippetNodeModal.current;
    case SurfaceNodeType.DocumentSnippet:
      return textSnippetNodeModal.current;
    case SurfaceNodeType.Form:
      console.log('RER FORM');
      return formModal.current;
  }
}

function showNodeModal(input: NodeModalInput): void {
  console.log('SHOW NODE MODAL ', input);
  const modal = getNodeTypeModalRef(input.type);
  console.log('SHOW NODE MODAL ', modal);
  if (modal) {
    modal.setData(input);
    modal.show();
    setModalTypeShown(input.type);
  }
}
